export const BOOK_VARIANTS = [
  { value: 'Amount', label: 'Amount only', to: false, from: false, body: false },
  { value: 'Message', label: 'Message only', to: false, from: false, body: true },
  { value: 'Receiver', label: 'Receiver only', to: true, from: false, body: false },
  { value: 'Sender', label: 'Sender only', to: false, from: true, body: false },
  { value: 'Receiver & Message', label: 'Receiver & Message', to: true, from: false, body: true },
  { value: 'Message & Sender', label: 'Message & Sender', to: false, from: true, body: true },
  { value: 'Receiver & Sender', label: 'Receiver & Sender', to: true, from: true, body: false },
];

export const QR_METHODS = [
  { value: 'zebra', label: 'Print with Zebra' },
  { value: 'pdf', label: 'Download PDF' },
];

export const LABEL_FIELDS = [
  { key: 'receiverName', label: 'Receiver name' },
  { key: 'senderName', label: 'Sender name' },
  { key: 'purchaseId', label: 'Purchase ID' },
  { key: 'amount', label: 'Amount' },
  { key: 'voucherId', label: 'Voucher ID' },
];

export const MAX_LABEL_FIELDS = 2;

export const PRINT_OPTIONS_INITIAL_STATE = {
  bookEnabled: false,
  bookVariant: BOOK_VARIANTS[0].value,

  qrEnabled: false,
  qrMethod: QR_METHODS[0].value,

  envelopeEnabled: false,
  envelopeFields: [],

  packageEnabled: false,
  packageFields: [],

  printing: false,
};
